<template>
  <div>
    <pageTable
      :col="accountListCol"
      :loading="tableLoading"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import Vue from 'vue'
import { getSubAccountList } from '@/api/userManager'
import { addTitle } from '@/utils/common'
export default {
  name: 'detailList',
  components: {
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      accountListCol: [
        { field: 'operation', title: '操作', width: 90, titleAlign: 'left', columnAlign: 'left', componentName: 'operateDetail' },
        { field: 'staff_no', title: '员工编号', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'company_name', title: '企业名称', width: 220, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return addTitle(rowData['company_name'])
          }
        },
        { field: 'user_name', title: '员工姓名', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'sex', title: '性别', width: 50, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['sex'] === '1') {
              return '<span>男</span>'
            } else if (rowData['sex'] === '2') {
              return '<span>女</span>'
            }
          }
        },
        { field: 'certificate_type_code', title: '证件类型', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter: function(rowData) {
            if (rowData['certificate_type_code'] === '01') {
              return '<span>身份证</span>'
            }
          }
        },
        { field: 'certificate_halfencrypt_number', title: '证件号码', width: 160, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'Login_id', title: '员工登录名', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'role_id', title: '角色编号', width: 120, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'role_name', title: '角色名称', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'create_time', title: '注册时间', width: 160, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'tel_no', title: '联系电话', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'email', title: '电子邮箱', width: 180, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData) {
            return addTitle(rowData['email'])
          }
        },
        { field: 'last_login_time', title: '最后登录时间', width: 160, titleAlign: 'left', columnAlign: 'left', isResize: true },
        { field: 'login_times', title: '登录次数', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true }
      ],
      companyId: '',
      corpTypeKey: '' // 1 工业 2 服务
    }
  },
  methods: {
    initPage() {
      const pageObj = { title: this.$route.name.indexOf('Verify') !== -1 ? '查看明细' : '账号列表', type: 'cover' }
      this.$route.name.indexOf('Industry') !== -1 ? pageObj.url = 'industryList' : pageObj.url = 'serverList'
      this.$store.dispatch('setPage', pageObj)
      this.corpTypeKey = this.$route.name.indexOf('Industry') !== -1 ? 1 : 2
      this.companyId = this.$route.params.id
    },
    getData() {
      this.tableLoading = true
      getSubAccountList({
        company_id: this.companyId,
        corp_type_key: this.corpTypeKey,
        current_page: this.page,
        rp: this.pageSize
      }).then(res => {
        this.tableLoading = false
        const { code, result } = res
        if (code === 0) {
          this.tableData = result.data
          this.total = result.count
        } else if (res.code !== 10008) {
          this.$Message.info('获取子账号失败')
          this.tableData = []
          this.total = 0
        }
      })
    }
  }
}
Vue.component('operateDetail', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    update() {
      const companType = this.$route.name === 'detailListServer' ? 'server' : 'industry'
      localStorage.setItem('routeName', this.$route.name)
      localStorage.setItem('routeParamsId', this.rowData.company_id)
      this.$router.push({
        path: '/detail/detail-info-edit-' + companType,
        query: {
          id: this.rowData.company_id,
          sellerId: this.rowData.seller_id
        }
      })
    },

    list(rowData) {
      const companType = this.$route.name === 'detailListServer' ? 'server' : 'industry'
      localStorage.setItem('routeName', this.$route.name)
      localStorage.setItem('routeParamsId', this.rowData.company_id)
      this.$router.push({
        path: '/detail/detail-info-' + companType,
        query: {
          id: this.rowData.company_id,
          sellerId: this.rowData.seller_id
        }
      })
    }
  },
  render: function(h) {
    return h('div', {
      class: {
        operate: true
      }
    }, [h('a', {
      on: {
        click: this.update
      }
    }, '编辑'), h('a', {
      on: {
        click: this.list
      }
    }, '查看')])
  }
})
</script>

